module.exports = __webpack_public_path__ + "img/2665c725b0530d0a45c6d0d038e5b63e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo14.png
// module id = 922
// module chunks = 5